module.exports = __webpack_public_path__ + "assets/img/borderimg.117a311f.png";